export default "__VITE_ASSET__CFMln$3l__"